import { render, staticRenderFns } from "./aRefPricesTableRow.vue?vue&type=template&id=28c96c87&scoped=true"
import script from "./aRefPricesTableRow.vue?vue&type=script&lang=js"
export * from "./aRefPricesTableRow.vue?vue&type=script&lang=js"
import style0 from "./aRefPricesTableRow.vue?vue&type=style&index=0&id=28c96c87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c96c87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VSpacer,VTooltip})
